export default __webpack_public_path__ + "static/media/miguel-lopes-26.9d5678ed.jpg";